/** How long to keep correcting scrollTop after open. iOS moves it after paint. */
export const PIN_SCROLL_DELAY_MS = 100;

type ScrollTarget = { scrollTop: number };

// iOS Safari scrolls an overflow region to the first select after paint.
// Pin again on the next frame and once more after a short delay so that jump loses.
export function pinScrollTop(node: ScrollTarget | null): () => void {
  if (!node) return () => {};
  const pin = () => {
    node.scrollTop = 0;
  };
  pin();
  let frame = 0;
  if (typeof requestAnimationFrame === 'function') {
    frame = requestAnimationFrame(pin);
  }
  const timer = setTimeout(pin, PIN_SCROLL_DELAY_MS);
  return () => {
    if (typeof cancelAnimationFrame === 'function') cancelAnimationFrame(frame);
    clearTimeout(timer);
  };
}
